import { Link, useNavigate } from "react-router-dom";
import { X, Plus, Minus } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, removeItem, total, count } = useCart();
  const navigate = useNavigate();

  return (
    <>
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 bg-black/40 z-[60] transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full sm:w-[440px] bg-white z-[70] flex flex-col transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex items-center justify-between px-6 h-16 border-b border-border">
          <h3 className="font-heading font-bold uppercase tracking-tight text-lg">Cart ({count})</h3>
          <button onClick={() => setOpen(false)} data-testid="cart-close" className="hover:text-accent"><X size={20} /></button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-10 text-center text-muted-foreground text-sm">Your cart is empty.</div>
          ) : (
            items.map((i) => (
              <div key={`${i.product_id}-${i.size}-${i.color}`} data-testid="cart-item" className="flex gap-4 p-6 border-b border-border">
                <img src={i.image} alt={i.name} className="w-20 h-24 object-cover bg-secondary" />
                <div className="flex-1">
                  <div className="font-medium text-sm">{i.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">Size: {i.size || "One"}{i.color ? ` · Colour: ${i.color}` : ""}</div>
                  <div className="font-mono text-sm mt-1">£{i.price.toFixed(2)}</div>
                  <div className="flex items-center gap-3 mt-2">
                    <button onClick={() => updateQty(i.product_id, i.size, i.color, i.quantity - 1)} className="border border-border p-1 hover:bg-secondary"><Minus size={12} /></button>
                    <span className="text-sm font-mono w-5 text-center">{i.quantity}</span>
                    <button onClick={() => updateQty(i.product_id, i.size, i.color, i.quantity + 1)} className="border border-border p-1 hover:bg-secondary"><Plus size={12} /></button>
                    <button onClick={() => removeItem(i.product_id, i.size, i.color)} className="ml-auto text-xs uppercase tracking-wider text-muted-foreground hover:text-accent">Remove</button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-border p-6">
            <div className="flex justify-between mb-4">
              <span className="text-xs font-bold uppercase tracking-[0.2em]">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-mono font-medium">£{total.toFixed(2)}</span>
            </div>
            <button
              data-testid="cart-checkout-button"
              onClick={() => { setOpen(false); navigate("/cart"); }}
              className="w-full bg-foreground text-background py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-black/80 transition-colors"
            >
              View Cart & Checkout
            </button>
            <Link to="/shop" onClick={() => setOpen(false)} className="block text-center mt-3 text-xs uppercase tracking-wider text-muted-foreground hover:text-accent">Continue Shopping</Link>
          </div>
        )}
      </aside>
    </>
  );
}
